import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  cardWrapper: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'unset',
    },
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginInline: {
      xs: '16px',
      md: '24px',
    },
    flexBasis: { xs: '100%', md: '80%' },
    marginTop: '40px',
  },
  sectionWrapper: {
    justifyContent: 'center',
  },
  sectionHeader: {
    textAlign: 'center',
    marginBottom: '16px',
  },
  videoWrapper: {
    display: 'flex',
    gap: '24px',
  },
  videoInnerWrapper: {
    maxWidth: '612px',
    maxHeight: '338px',
  },
  video: {
    maxWidth: '612px',
    maxHeight: '338px',
  },
  card: {
    position: 'relative',
    border: '1px solid',
    borderColor: 'border.light',
    backgroundColor: 'background.paperDark',
    borderRadius: '16px',
    padding: '24px',
    maxWidth: {
      xs: '330px',
      md: '394px',
    },
    minWidth: {
      xs: '330px',
      md: '394px',
    },
    minHeight: {
      xs: '285px',
      md: '285px',
    },
    maxHeight: {
      xs: '285px',
      md: '285px',
    },
    flexShrink: 0,
    marginRight: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  ratingWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: {
      xs: 'center',
      md: 'unset',
    },
    maxWidth: '712px',
    alignSelf: 'center',
    gap: {
      xs: '16px',
      md: '32px',
    },
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
  },
  leftRatingWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '18px',
  },
  ratingCompanyWrapper: {
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    aspectRatio: '16/9',
  },
  ratingCompany: {
    width: 'auto !important',
    height: '32px',
    ' img': {
      maxHeight: '100%',
      objectFit: 'contain',
    },
    scale: 1.6,
    paddingTop: '3px',
    marginLeft: '8px',
  },
  ratingFeatured: {
    width: 'auto !important',
    height: '18px',
    ' img': {
      minHeight: '100% ',
      objectFit: 'contain',
    },
  },
  divider: {
    height: '68px',
    backgroundColor: 'border.light',
    display: {
      xs: 'none',
      md: 'unset',
    },
  },
  ratingDescription: {
    maxWidth: {
      xs: 'unset',
      md: '340px',
    },
    color: 'text.secondaryDark',
    textAlign: {
      xs: 'center',
      md: 'unset',
    },
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
